let accordions = document.querySelectorAll(".product-description .desc-head");
let tabsButton = document.querySelectorAll(
  ".description-heading .heading-button"
);
let mediaWrapper = document.querySelector(".product-container .product-media-wrapper");
let mediaThumbs = document.querySelector(".product-container .slider-thumbs");
let tabs = document.querySelectorAll(".desc-block");
////////////////////Products deffered media toggler
let toggleButton = document.querySelectorAll(".media-toggle");
toggleButton.forEach(function (el, ind) {
  el.addEventListener("click", function () {
    let parent = el.closest(".product-media-container");
    let template = parent.querySelector("template");
    template ? parent.insertAdjacentHTML("beforeend", template.innerHTML) : "";
    parent.setAttribute("data-loaded", "true");
  });
});
////////////////////Product description toggle
accordions.forEach(function (el, ind) {
  el.addEventListener("click", function (e) {
    let parent = el.closest(".desc-block");
    parent.classList.toggle("open");
  });
});
///////////////////Tabs toggle
tabsButton.forEach(function (el, ind) {
  el.addEventListener("click", function () {
    tabsButton.forEach((btn,ind)=>{
      btn == el ? btn.classList.add("active") : btn.classList.remove("active");
    })
    let dataIndex = el.dataset.val;
    tabs.forEach((el, ind) => {
      if (el.dataset.id == dataIndex) {
        el.classList.add("active");
        el.classList.add("open");
      } else {
        el.classList.remove("active");
        el.classList.remove("open");
      }
    });
  });
});
////////////////////Prevent submission

document.querySelector(".ajax-cart .prevent_click").addEventListener("click",function(e){
    e.stopPropagation();
  let nameField = document.querySelector(".input-block input[name='fullName']");
  let maleField = document.querySelector(".input-block #male");
  let femaleField = document.querySelector(".input-block #female");
  let tobField = document.querySelector(".input-block input[name='time-of-birth']");
  let dobField = document.querySelector(".input-block input[name='date-of-birth']");
  let pobField = document.querySelector(".input-block input[name='place-of-birth']");
  let latField = document.querySelector(".input-block input[name='latitude']");
  let longField = document.querySelector(".input-block input[name='longitude']")
  let langField = document.querySelector(".input-block input[name='language']");
  let kundliForField = document.querySelector(".input-block input[name='rotateKundli']");
  let phoneField = document.querySelector(".input-block input[name='phone']");
  let nameFieldStatus = false;
  let genderFieldStatus = false;
  let tobFieldStatus = false;
  let dobFieldStatus = false;
  let pobFieldStatus = false;
  let langFieldStatus = false;
  let kundliForFieldStatus = false;
  let phoneFieldStatus = false;
  let form = this.closest("form");
  form.addEventListener("submit",(e)=> e.preventDefault());
  nameField.value.trim().length != 0 ? nameFieldStatus = true : nameFieldStatus = false;
  maleField.checked || femaleField.checked ? genderFieldStatus = true : genderFieldStatus = false;
  tobField.value.trim().length != 0 ? tobFieldStatus = true : tobFieldStatus = false;
  dobField.value.trim().length != 0 ? dobFieldStatus = true : dobFieldStatus = false;
  pobField.value.trim().length != 0 && latField.value.trim().length != 0 && latField.value != "undefined" && longField.value.trim().length != 0 && longField.value != "undefined" ? pobFieldStatus = true : pobFieldStatus = false;
  langField.value.trim().length != 0 ? langFieldStatus = true : langFieldStatus = false;
  phoneField.dataset.valid == "true" ? phoneFieldStatus = true : phoneFieldStatus = false;
  kundliForField.value.trim().length != 0 ? kundliForFieldStatus = true : kundliForFieldStatus = false;
  console.log(nameField.value.trim().length,genderFieldStatus,tobFieldStatus,dobFieldStatus,pobFieldStatus)
  if(nameFieldStatus && genderFieldStatus && tobFieldStatus && dobFieldStatus && pobFieldStatus && langFieldStatus && kundliForFieldStatus && phoneFieldStatus ){
    document.querySelector(".form-alert").style.display = "none";
    nameField.value = "";
    maleField.checked = false;
    femaleField.checked = false;
    tobField.value = "";
    dobField.value = "";
    pobField.value = "";
    this.closest(".ajax-cart").click();
  }else{
    console.log(pobFieldStatus,"pobfield status")
    !nameFieldStatus ? nameField.closest(".form-block").classList.add("error") : nameField.closest(".form-block").classList.remove("error");
    !genderFieldStatus ? femaleField.closest(".form-block").classList.add("error") : femaleField.closest(".form-block").classList.remove("error");
    !tobFieldStatus ? tobField.closest(".form-block").classList.add("error") : tobField.closest(".form-block").classList.remove("error");
    !dobFieldStatus ? dobField.closest(".form-block").classList.add("error") : dobField.closest(".form-block").classList.remove("error");
    !pobFieldStatus ? pobField.closest(".form-block").classList.add("error") : pobField.closest(".form-block").classList.remove("error");
    !langFieldStatus ? langField.closest(".form-block").classList.add("error") : langField.closest(".form-block").classList.remove("error");
    !kundliForFieldStatus ? kundliForField.closest(".form-block").classList.add("error") : kundliForField.closest(".form-block").classList.remove("error");
    !phoneFieldStatus ? phoneField.closest(".form-block").classList.add("error") : phoneField.closest(".form-block").classList.remove("error");
    document.querySelector(".form-alert").style.display = "flex";
  }
})
function updateDeliveryText(){
  let inputs = Array.from(document.querySelectorAll(".product--info input[name='input-File Type']"));
  if(inputs.length == 0) return;
  inputs.forEach((el,ind)=>{
      el.checked ? el.value == "Soft Copy" ? document.querySelector(".delivery_text").textContent = 'Estimated Delivery 24 Hrs' : document.querySelector(".delivery_text").textContent = 'Estimated Delivery: 7-10 Days' : "";
    el.addEventListener("change",()=>{
      el.checked ? el.value == "Soft Copy" ? document.querySelector(".delivery_text").textContent = 'Estimated Delivery 24 Hrs' : document.querySelector(".delivery_text").textContent = 'Estimated Delivery: 7-10 Days' : "";
    })
  })
}
updateDeliveryText();
window.addEventListener("load",()=>{
  console.log("ready")
  if(mediaThumbs){
    mediaWrapper.style.paddingBottom = mediaThumbs.querySelector(".slider-thumbnail").clientHeight + 25 + "px";
  }
})